"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationModal = exports.ConfirmationMessage = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _styles = require("../../Modal/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ConfirmationMessage = exports.ConfirmationMessage = _styledComponents.default.span.withConfig({
  displayName: "styles__ConfirmationMessage",
  componentId: "sc-1uc9hga-0"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], ({
  theme
}) => theme.modals.content.fontFamily, ({
  theme
}) => theme.modals.content.fontSize, ({
  theme
}) => theme.modals.content.fontWeight, ({
  theme
}) => theme.modals.content.lineHeight);
const ConfirmationModal = exports.ConfirmationModal = (0, _styledComponents.default)(_Modal.default).withConfig({
  displayName: "styles__ConfirmationModal",
  componentId: "sc-1uc9hga-1"
})(["", "{width:560px;min-width:560px;max-width:560px;", "}", "{display:flex;}", "{flex:1;display:flex;justify-content:center;align-items:", ";}"], _styles.ModalContainer, ({
  image
}) => !image && (0, _styledComponents.css)(["height:262px;"]), _styles.Body, _styles.Content, ({
  theme
}) => theme.modals.confirmAlignment);